import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import {
  makeStyles,
  CircularProgress,
  AppBar,
  Drawer,
  Divider,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  SvgIcon,
  Typography,
  Collapse,
} from '@material-ui/core'
import lsLogo from '../../assets/lsDirectNEW_Reverse.png'
import sdLogo from '../../assets/SmartDash_darkbg.png'
import NotificationsPanel from '../Notifications'
import UserMenu from '../user/GeneralMenu'
import DarkThemeToggle from '../user/DarkThemeSwitch'
import { RiHome4Fill, RiExchangeDollarFill } from 'react-icons/ri'
import { BiCalendarEvent, BiDirections } from 'react-icons/bi'
import { SiTableau } from 'react-icons/si'
import { IoPeople } from 'react-icons/io5'
import { TiLocation, TiHeartFullOutline } from 'react-icons/ti'
import { FilterNone, PieChart, Assessment, MonetizationOn, Traffic, Telegram, MarkunreadMailbox, Assignment, HowToReg, ShoppingCart, Sync, Public, LocationOn, Timeline, ExpandLess, ExpandMore } from '@material-ui/icons'
import Cookies from 'js-cookie'

const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/"
// const base_url= "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm"
const drawerWidth = 240

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  profileDrawerPaper: {
    width: drawerWidth,
    square: true,
  },
  appBar: {
    zIndex: theme.zIndex.drawer - 1,
    background: 'linear-gradient(to right bottom, #2b2b2b, #3d3d3d)',
    boxShadow: '0 1px 5px rgba(0, 0, 0, 0.16), 0 2px 6px rgba(0, 0, 0, 0.1)',
    square: true,
    padding: theme.spacing(1),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: drawerWidth,
  },
  nav: {
    [theme.breakpoints.up('sm')]: {
      width: 0,
      flexShrink: 0,
      zIndex: theme.zIndex.appBar - 1,
    },
    overflowX: 'scroll',
  },
  navOpen: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    overflowX: 'hidden',
    width: 300,
    backgroundColor: '#212121',
  },
  navClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overlflowX: 'hidden',
    background: 'linear-gradient(to bottom, #2b2b2b, #3d3d3d)',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(7) + 1,
    }
  },
  content: {
    flexGrow: 1,
    // padding: theme.spacing(0, 0, 5, 0),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // margin: '1em',
    marginLeft: theme.spacing(7),
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    // margin: '1em',
    marginLeft: theme.spacing(7) + drawerWidth,
  },
  toolbar: {
    display: 'flex',
    // alignItems: 'center',
    // padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end'
  },
}))

const Boom = (props) => (
  <SvgIcon {...props}>
    <path d="M10 2H4C2.9 2 2 2.9 2 4S2.9 6 4 6H8L10 2M18 2C20.2 2 22 3.8 22 6V12L18 14C18 9.6 14.4 6 10 6L12 2H18M18 20V16L22 14V20C22 21.1 21.1 22 20 22S18 21.1 18 20Z" />
  </SvgIcon>
)

const getCategories = () => {
  const cat = [
    {category: 'Home Page', icon: <RiHome4Fill style={{fontSize: '24px'}}/>, nested: false, path: '/' },
    // {category: 'Calendar', icon: <BiCalendarEvent style={{fontSize: '24px'}}/>, nested: false, path: '/calendar' },
    {category: 'Calendar', icon: <BiCalendarEvent style={{fontSize: '24px'}}/>, nested: false, path: '/calendar' },
    {category: 'Roi', icon: <RiExchangeDollarFill style={{fontSize: '24px'}}/>, nested: true },
    {category: 'Promotions', icon: <FilterNone style={{fontSize: '19px'}}/>, nested: true },
    {category: 'Customers', icon: <IoPeople style={{fontSize: '20px'}}/>, nested: true },
    {category: 'Demographics', icon: <PieChart style={{fontSize: '22px'}}/>, nested: true },
    {category: 'Marketing', icon: <Assessment style={{fontSize: '24px'}}/>, nested: true },
    {category: 'Sales', icon: <MonetizationOn style={{fontSize: '22px'}}/>, nested: true },
    {category: 'Traffic', icon: <Traffic style={{fontSize: '25px'}}/>, nested: true },
    {category: 'Location Details', icon: <TiLocation style={{fontSize: '25px'}}/>, nested: true },
  ]

  return cat
}

const getNestedItems = (categories) => {
  let tableau = JSON.parse(localStorage.getItem("tableauScreens")) ? JSON.parse(localStorage.getItem("tableauScreens")).filter(({access}) => access === 1) : []
  
  const nestedScreens = [
    {category: 'Roi', path: '/boomerang', screenName: 'Boomerang', short_name: 'Boomerang', icon: <Boom style={{fontSize: '20px'}}/>,},
    {category: 'Roi', path: '/boomerang/lost-opportunity', screenName: 'Boomerang Lost Opportunity', short_name: 'Boomerang Lost Opp', icon: <BiDirections style={{fontSize: '22px'}}/>,},
    {category: 'Roi', path: '/triggers', screenName: 'Triggers', short_name: 'Triggers', icon: <Telegram style={{fontSize: '20px'}}/>,},
    {category: 'Roi', path: '/event-marketing', screenName: 'Event Marketing', short_name: 'Event Marketing', icon: <MarkunreadMailbox style={{fontSize: '20px'}} />,},
    {category: 'Roi', path: '/product-performance', screenName: 'Product Performance', short_name: 'Product Performance', icon: <Assignment style={{fontSize: '20px'}} />,},
    {category: 'Customers', path: '/rfm-counts', screenName: 'RFM Counts', short_name: 'RFM Counts', icon: <HowToReg style={{fontSize: '20px'}} />,},
    {category: 'Customers', path: '/otb-counts', screenName: 'OTB Counts', short_name: 'OTB Counts', icon: <ShoppingCart style={{fontSize: '20px'}} />,},
    {category: 'Customers', path: '/customer-retention', screenName: 'Customer Retention', short_name: 'Customer Retention', icon: <Sync style={{fontSize: '20px'}} />,},
    {category: 'Demographics', path: '/cpr-stats', screenName: 'CPR Stats', short_name: 'CPR Stats', icon: <TiHeartFullOutline style={{fontSize: '20px'}} />,},
    // {category: 'Demographics', path: '/demographics', screenName: 'Demographics By Location', short_name: 'Demo By Loc', icon: <Public style={{fontSize: '20px'}} />,},    
    {category: 'Demographics', path: '/demographics', screenName: 'Demographics By Location', short_name: 'Demo By Loc', icon: <Public style={{fontSize: '20px'}} />,},
    {category: 'Demographics', path: '/zip-code', screenName: 'YOY Sales By Zip', short_name: 'YOY Sales By Zip', icon: <LocationOn style={{fontSize: '20px'}} />,},
    {category: 'Demographics', path: '/demographic-trends', screenName: 'Demographic Trends', short_name: 'Demographic Trends', icon: <Timeline style={{fontSize: '20px'}} />,},
    // {category: 'Demographics', path: '/demo-by-loc', screenName: 'Demographics By Location', short_name: 'Demo By Loc', icon: <Public style={{fontSize: '20px'}} />,},
    // {category: 'Roi', path: '/boomerang', screenName: 'Boomerang', short_name: 'Boomerang', icon: <Boom style={{fontSize: '20px'}}/>,},
    // {category: 'Roi', path: '/boomerang/lost-opportunity', screenName: 'Boomerang Lost Opportunity', short_name: 'Boomerang Lost Opp', icon: <BiDirections style={{fontSize: '22px'}}/>,},
    // {category: 'Roi', path: '/trigger', screenName: 'Triggers', short_name: 'Triggers', icon: <Telegram style={{fontSize: '20px'}}/>,},
    // {category: 'Roi', path: '/event-marketing', screenName: 'Event Marketing', short_name: 'Event Marketing', icon: <MarkunreadMailbox style={{fontSize: '20px'}} />,},
    // {category: 'Roi', path: '/product-performance', screenName: 'Product Performance', short_name: 'Product Performance', icon: <Assignment style={{fontSize: '20px'}} />,},
    // {category: 'Customers', path: '/rfm-counts', screenName: 'RFM Counts', short_name: 'RFM Counts', icon: <HowToReg style={{fontSize: '20px'}} />,},
    // {category: 'Customers', path: '/otb-counts', screenName: 'OTB Counts', short_name: 'OTB Counts', icon: <ShoppingCart style={{fontSize: '20px'}} />,},
    // {category: 'Customers', path: '/customer-retention', screenName: 'Customer Retention', short_name: 'Customer Retention', icon: <Sync style={{fontSize: '20px'}} />,},
    // {category: 'Demographics', path: '/demographic', screenName: 'Demographics By Location', short_name: 'Demo By Loc', icon: <Public style={{fontSize: '20px'}} />,},
    // {category: 'Demographics', path: '/zip-code', screenName: 'YOY Sales By Zip', short_name: 'YOY Sales By Zip', icon: <LocationOn style={{fontSize: '20px'}} />,},
    // {category: 'Demographics', path: '/demographic-trends', screenName: 'Demographic Trends', short_name: 'Demographic Trends', icon: <Timeline style={{fontSize: '20px'}} />,},
  ]

  // console.log(tableau)

  for(let i = 0; i < categories.length; i++) {
    categories[i]["nestedArr"] = []
    for(let j = 0; j < nestedScreens.length; j++) {
      if(nestedScreens[j]["category"] === categories[i]["category"]) {
        categories[i]["nestedArr"].push(nestedScreens[j])
      }
    }
    
    for(let k = 0; k < tableau.length; k++) {
      if(tableau[k].category_name === "Dashboard" && categories[i].category === "Sales") categories[i].nestedArr.push(tableau[k])
      else if(tableau[k].category_name === categories[i].category) categories[i].nestedArr.push(tableau[k])
    }
  }  

  return categories
}

export default function Navbar(props) {
  // const { dark } = props
  const { children, dark } = props
  const token = Cookies.get("token")
  const classes = useStyles()
  const categories = getCategories()
  const nestedItems = getNestedItems(categories)
  const [user, setUser] = useState(null)
  const [navOpen, setNavOpen] = useState(false)
  const [nestedCat, setNestedCat] = useState({roiOpen: false, promotionsOpen:false, customersOpen: false, demographicsOpen: false, salesOpen: false, trafficOpen: false, locationOpen: false})
  // const [darkMode, setDarkMode] = useState(true)

  const getUser = () => {
    const request = fetch(`${base_url}/user`, {
      headers: {
        token: token
      }
    })

    request.then(response => response.json())
    .then(data => {
      setUser(data[0])
    })
    .catch(error => console.log(error))
  }

  useEffect(() => getUser(), [])

  const handleNavOpen = () => {
    setNavOpen(true)
  }

  const handleNavClose = () => {
    setNavOpen(false)
    Object.keys(nestedCat).forEach((key) => {
      setNestedCat((prevState) => ({...prevState, [key]: false}))
    })
  }

  const handleOpenNested = (category) => {
    let cat = category.toLowerCase()
    setNestedCat((prevState) => ({...prevState, [`${cat}Open`]: !nestedCat[`${cat}Open`]}))
  }

  const handleLogout = () => {
    props.handleLogout()
  }

  const handleDarkThemeToggle = () => {
    props.handleDarkThemeToggle()    
  }

  const navDrawer = (
    <div>
      <div className={classes.toolbar} />
      <Divider />    
      <MenuList>
        {categories.map((navItem, i) => (
          <div key={`nav-${i}`} className="menu-item">
            <MenuItem
              component={!navItem.nested ? Link : null}
              to={navItem.path}
              onClick={navItem["nested"] ? () => handleOpenNested(navItem["category"]) : null}
              style={navItem.nested && navItem.nestedArr.length < 1 ? {display: "none"} : {}}
            >
              <ListItemIcon className="icon">
                {navItem.icon}
              </ListItemIcon>
              <ListItemText
                primary={<Typography className="text" variant="caption">{navItem.category.toUpperCase()}</Typography>}
              />
              {navItem.nested ? nestedCat[`${navItem.category.toLowerCase()}Open`] ? <ExpandLess className="icon" /> : <ExpandMore className="icon"/> : null}
            </MenuItem>
            <Collapse in={nestedCat[`${navItem.category.toLowerCase()}Open`]} timeout="auto" unmountOnExit>
              <MenuList className="nested">
                {navItem.nestedArr.map((nestItem, i) => (
                  <MenuItem
                    key={`nest-${i}`}
                    component={Link}
                    to={nestItem.path ? nestItem.path : `/${nestItem.display}`}
                  >                    
                    <ListItemIcon className="icon">{nestItem.icon !== "<EqualizerIcon />" ? nestItem.icon : <SiTableau />}</ListItemIcon>
                    <ListItemText
                      secondary={<Typography variant="caption" className="text">{nestItem.short_name.toUpperCase()}</Typography>}
                    />
                  </MenuItem>
                ))}
              </MenuList>
            </Collapse>
          </div>
        ))}
      </MenuList>
    </div>
  )

  if(!user) return <CircularProgress className="app-loader"/>

  return (
    <div className={classes.root}>      
      <AppBar
        position="fixed"
        className={clsx(classes.appBar)}
        >
          <div className="app-bar">
            <img src={lsLogo} className="logo ls" />
            <Divider orientation="vertical" />
            <Typography variant="caption" className="company-name">{user.company ? user.company.toUpperCase() : ""}</Typography>
            <div className="grow" />
            <div className="desktop-appbar">
              <img src={sdLogo} className="logo sd" />
              <Divider orientation="vertical" className="divider" />
              <NotificationsPanel />
              <Divider orientation="vertical" className="divider" />
              <DarkThemeToggle darkThemeSwitch={handleDarkThemeToggle}/>
              <Divider orientation="vertical" className="divider" />
              <UserMenu handleLogout={handleLogout} userLvl={user.admin_level}/>
            </div>
          </div>
        </AppBar>
        <nav className={classes.nav}>
          <Drawer
            variant="permanent"
            // open={true}
            className={clsx(classes.nav, {[classes.navOpen]: navOpen, [classes.navClose]: !navOpen})}
            classes={{paper: clsx({[classes.navOpen]: navOpen, [classes.navClose]: !navOpen})}}
            onMouseOver={handleNavOpen}
            onMouseLeave={handleNavClose}
            open={navOpen}
          >
            {navDrawer}
          </Drawer>
        </nav>
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: navOpen
          })}
        >
          
          <div className={clsx("smartdash-content", {["content-dark"]: props.dark, ["content-light"]: !props.dark})}>
            <div className={classes.toolbar} />
            {children}
          </div>
        </main>
    </div>
  )
}
